import { apiCall } from '../helpers/apiHelpers';
import { ApiResult } from '../types/api/common';
import { AgreementResponse } from '../types/api/responses';

export const agreementService = (sessionId: string): Promise<ApiResult<AgreementResponse>> =>
  apiCall<AgreementResponse>({
    method: 'GET',
    url: `/client/agreement?clientSessionId=${sessionId}`,
  })();
